// Bouton "Filtrer" pour ouvrir les filtres en version mobile
const filtersToggler = document.getElementById('toggle-formations-filters');
const categoryTree = document.getElementById('formations-filter');

if (typeof(filtersToggler) != 'undefined' && filtersToggler != null) {
  filtersToggler.addEventListener('click', () => {
    const isActive = filtersToggler.classList.contains('active');

    // Ouvrir celui cliqué
    if (!isActive) {
      filtersToggler.classList.add('active');
      filtersToggler.setAttribute('aria-expanded', 'true');
      categoryTree.classList.add('filters--opened')
    } else {
      filtersToggler.classList.remove('active');
      filtersToggler.setAttribute('aria-expanded', 'false');
      categoryTree.classList.remove('filters--opened')
    }
  });
}

const form = document.getElementById('filter-formations');

if (form) {
  form.addEventListener('submit', (e) => {
    e.preventDefault();

    const params = new URLSearchParams();

    const thematique = [...form.querySelectorAll('input[name="filter-thematique"]:checked')]
      .map(i => i.value)
      .join(',');
    if (thematique) params.set('filter-thematique', thematique);

    const localisation = [...form.querySelectorAll('input[name="filter-localisation"]:checked')]
      .map(i => i.value)
      .join(',');
    if (localisation) params.set('filter-localisation', localisation);

    const format = [...form.querySelectorAll('input[name="filter-format"]:checked')]
    .map(i => i.value)
    .join(',');
    if (format) params.set('filter-format', format);

    const action = form.getAttribute('action') || window.location.pathname;
    window.location.href = `${action.split('?')[0]}?${params.toString()}`;
  });
}
